import {DraftErrorsFactory} from '../Errors/factory.js'
import {DraftEntity} from './DraftEntity.js'

export class DraftEntitiesFactory {
  /**
   * @method
   * @param {DraftResponse} draft
   * @return {ContractEntity}
   */
  static draftEntity = draft => {
    DraftEntity.validate({
      id: draft.id,
      userId: draft.userId,
      invalidDraftError: DraftErrorsFactory.invalidDraftError
    })
    return new DraftEntity(draft)
  }
}
